"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinType = void 0;
const definitions_1 = require("@ppay/definitions");
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
exports.CoinType = {
    [definitions_1.Ticker.BTC]: 0,
    [definitions_1.Ticker.ETH]: 60,
    [definitions_1.Ticker.TRX]: 195
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29pblR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29pbnMvQ29pblR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsbURBQTBDO0FBRTFDLGdFQUFnRTtBQUNuRCxRQUFBLFFBQVEsR0FBRztJQUN0QixDQUFDLG9CQUFNLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQztJQUNmLENBQUMsb0JBQU0sQ0FBQyxHQUFHLENBQUMsRUFBRSxFQUFFO0lBQ2hCLENBQUMsb0JBQU0sQ0FBQyxHQUFHLENBQUMsRUFBRSxHQUFHO0NBQ2xCLENBQUEifQ==